import { render } from "./zdspbhindex.vue?vue&type=template&id=6e0391c6&scoped=true"
import script from "./zdspbhindex.vue?vue&type=script&lang=js"
export * from "./zdspbhindex.vue?vue&type=script&lang=js"

import "./zdspbhindex.vue?vue&type=style&index=0&id=6e0391c6&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0391c6"]])

export default __exports__